// Contenu partagé du site — mêmes données que le dépliant, ton clinique et sobre.

export const CABINET = {
    name: "ANA Corps & Souffle",
    tagline: "Cabinet de physiothérapie",
    subtagline: "Cardio-respiratoire · Rééducation du périnée · Physiothérapie générale",
    practitioner: "Ana Corps & Souffle",
    title: "Physiothérapeute diplômée",
    address: "Rue Centrale 27",
    city: "1880 Bex",
    canton: "Canton de Vaud",
    phone: "079 672 32 46",
    phoneIntl: "+41796723246",
    email: "contact@anacorpsetsouffle.ch",
};

export const DOMAINS = [
    {
        id: "cardio",
        num: "01",
        title: "Cardio-respiratoire",
        subtitle: "Souffle · Effort · Récupération",
        lead: "Prise en charge des pathologies respiratoires et rééducation à l'effort. Séances individuelles, protocoles progressifs, éducation à la gestion de la dyspnée.",
        picto: "/assets/picto_cardio.png",
        color: "sage",
        indications: [
            "BPCO, emphysème, asthme sévère",
            "Post-COVID et séquelles respiratoires",
            "Bronchectasies, mucoviscidose adulte",
            "Réhabilitation respiratoire complète",
            "Toux chronique et respiration paradoxale",
            "Rééducation post-opératoire thoracique",
            "Réadaptation cardio-vasculaire ambulatoire",
            "Désencombrement bronchique (adulte et pédiatrie)",
            "Reconditionnement à l'effort",
            "Éducation thérapeutique et gestion de la dyspnée",
        ],
    },
    {
        id: "perinee",
        num: "02",
        title: "Périnée",
        subtitle: "Pelvi-périnéologie · Pré & post-partum",
        lead: "Rééducation périnéale de la femme, en pré et post-partum et à tous les âges. Bilan initial complet, approche manuelle, biofeedback, exercices personnalisés.",
        picto: "/assets/picto_perinee.png",
        color: "terra",
        indications: [
            "Incontinence urinaire d'effort et par urgenturie",
            "Prolapsus génito-urinaires (stades I à III)",
            "Préparation à l'accouchement et récupération post-partum",
            "Diastase des grands droits",
            "Douleurs pelvi-périnéales chroniques (vulvodynie, cystalgie)",
            "Endométriose et douleurs pelviennes",
            "Rééducation post-mastectomie et drainage lymphatique",
            "Post-chirurgie gynécologique",
            "Approche manuelle, biofeedback, électrostimulation",
            "Exercices personnalisés à domicile",
        ],
    },
    {
        id: "general",
        num: "03",
        title: "Physiothérapie générale",
        subtitle: "Musculo-squelettique · Aigu & chronique",
        lead: "Traitement des pathologies musculo-squelettiques aiguës et chroniques. Thérapie manuelle, reprise d'activité progressive, prévention des récidives.",
        picto: "/assets/picto_general.png",
        color: "forest",
        indications: [
            "Lombalgies, cervicalgies, dorsalgies",
            "Tendinopathies (épaule, coude, hanche, genou)",
            "Suites de fractures et de chirurgie orthopédique",
            "Entorses et lésions ligamentaires",
            "Arthrose et pathologies dégénératives",
            "Rééducation proprioceptive et prévention des chutes",
            "Reprise progressive d'activité physique",
        ],
    },
];

export const WHY_REFER = [
    {
        heading: "Prise en charge en cabinet ou à domicile",
        body: "Consultations sur rendez-vous, en français, dans un cadre calme au cabinet ou directement chez le patient (Bex et Chablais vaudois).",
    },
    {
        heading: "Approche clinique documentée",
        body: "Anamnèse détaillée, objectifs de traitement partagés, compte-rendu systématique au médecin traitant.",
    },
    {
        heading: "Trois domaines de spécialisation",
        body: "Cardio-respiratoire, rééducation périnéale, physiothérapie générale.",
    },
    {
        heading: "Continuité de soins",
        body: "Coordination active avec médecins traitants, spécialistes et sages-femmes de la région.",
    },
    {
        heading: "Vingt-six ans de pratique clinique",
        body: "Expérience en milieu hospitalier et ambulatoire, formation continue régulière.",
    },
];

export const EXPERIENCE = [
    {
        heading: "Parcours hospitalier",
        body: "Services de médecine interne, chirurgie, soins intensifs et pneumologie. Prise en charge de patients aigus et post-opératoires.",
    },
    {
        heading: "Pratique ambulatoire",
        body: "Suivi au long cours en cabinet : pathologies chroniques, rééducation post-hospitalisation, prévention et reprise d'activité.",
    },
    {
        heading: "Praticienne formatrice",
        body: "Accompagnement d'étudiants et de jeunes diplômés. Formation continue régulière en cardio-respiratoire et périnéologie.",
    },
    {
        heading: "Coordination interprofessionnelle",
        body: "Collaboration régulière avec médecins généralistes, spécialistes, sages-femmes et infirmières indépendantes.",
    },
];

export const COMPETENCES = [
    "Thérapie manuelle",
    "Rééducation neuro-motrice",
    "Drainage lymphatique manuel",
    "Kinésithérapie respiratoire",
    "Biofeedback périnéal",
    "Électrothérapie antalgique",
    "Éducation thérapeutique",
];

export const DOMAIN_LABEL = {
    cardio: "Cardio-respiratoire",
    perinee: "Périnée",
    general: "Physiothérapie générale",
    autre: "Autre / question générale",
};

export const SLOT_LABEL = {
    matin: "Matin",
    "apres-midi": "Après-midi",
};

export const LOCATION_LABEL = {
    cabinet: "En cabinet",
    domicile: "À domicile",
};

export const LOCATION_OPTIONS = [
    {
        id: "cabinet",
        title: "En cabinet",
        subtitle: "Rue Centrale 27 · 1880 Bex",
        body: "Consultation au cabinet, cadre calme et matériel de rééducation adapté.",
    },
    {
        id: "domicile",
        title: "À domicile",
        subtitle: "Bex et région (Chablais vaudois)",
        body: "Prise en charge chez le patient — mobilité réduite, post-hospitalisation, personnes âgées.",
    },
];

/**
 * Grille des pathologies prises en charge — inspirée des grilles cliniques
 * suisses (esprit factuel, pas de superlatif). Chaque item = un bloc.
 */
export const PATHOLOGIES = [
    { title: "Respiration & Souffle", subtitle: "Spécialité", cat: "respi", body: "BPCO, asthme sévère, post-COVID, hyperventilation, respiration dysfonctionnelle.", highlight: true },
    { title: "Rééducation périnéale", subtitle: "Spécialité", cat: "perinee", body: "Incontinence, prolapsus, pré et post-partum, douleurs pelvi-périnéales chroniques.", highlight: true },
    { title: "Cardio-vasculaire", cat: "respi", body: "Réadaptation ambulatoire post-infarctus, post-chirurgie cardiaque, insuffisance cardiaque chronique." },
    { title: "Désencombrement bronchique — adulte & pédiatrie", cat: "respi", body: "Techniques manuelles adaptées à l'âge (AFE, ELPr, drainage autogène) pour évacuer les sécrétions et améliorer la ventilation. Prise en charge du nourrisson à l'adulte." },
    { title: "Post-COVID long", cat: "respi", body: "Fatigue chronique, dyspnée, brouillard cognitif, intolérance à l'effort — approche graduée." },
    { title: "Réhabilitation respiratoire", cat: "respi", body: "Programme complet endurance, force et éducation thérapeutique pour l'insuffisant respiratoire chronique." },
    { title: "Toux chronique & respiration paradoxale", cat: "respi", body: "Reprogrammation du schéma ventilatoire, rééducation diaphragmatique et laryngée." },
    { title: "Endométriose & douleurs pelviennes", cat: "perinee", body: "Approche manuelle, désensibilisation, exercices ciblés — en lien avec le suivi gynécologique." },
    { title: "Rééducation post-mastectomie", cat: "perinee", body: "Récupération de la mobilité de l'épaule, drainage lymphatique, prévention du lymphœdème." },
    { title: "Diastase des grands droits", cat: "perinee", body: "Bilan et reprogrammation abdomino-périnéale en post-partum ou après amaigrissement important." },
    { title: "Douleurs pelvi-périnéales chroniques", cat: "perinee", body: "Vulvodynies, cystalgies, névralgies pudendales — approche manuelle et éducation." },
    { title: "Orthopédie", cat: "general", body: "Suites de fractures, entorses, tendinopathies, récupération post-opératoire, prothèses de hanche et de genou." },
    { title: "Rhumatologie", cat: "general", body: "Arthroses, polyarthrite, douleurs articulaires chroniques, prise en charge globale." },
    { title: "Lombalgies & cervicalgies", cat: "general", body: "Aiguës et chroniques, approche graduée éducation + mouvement + thérapie manuelle." },
    { title: "Thérapie manuelle", cat: "general", body: "Mobilisations articulaires, techniques neuromusculaires, drainage lymphatique manuel." },
    { title: "Rééducation à la marche", cat: "general", body: "Reprogrammation du schéma de marche après blessure, chirurgie ou perte de mobilité." },
    { title: "Prévention des chutes", cat: "general", body: "Évaluation et amélioration de l'équilibre, de la force et de la coordination chez la personne âgée." },
    { title: "Rééducation à l'effort", cat: "general", body: "Programmes progressifs d'endurance et de force pour retrouver capacité physique et geste sportif." },
    { title: "Éducation thérapeutique", cat: "general", body: "Compréhension de la pathologie, gestes du quotidien, autonomie dans la gestion du symptôme." },
];

export const PATHOLOGY_CATEGORIES = [
    { id: "all", label: "Toutes" },
    { id: "respi", label: "Respiratoire" },
    { id: "perinee", label: "Périnée" },
    { id: "general", label: "Général" },
];

export const DOMICILE_ZONE_TOWNS = [
    "Bex", "Aigle", "Ollon", "Monthey", "Massongex", "Villeneuve",
    "Roche", "Yvorne", "Leysin", "Villars-sur-Ollon", "Bouveret", "Vionnaz",
];

export const CABINET_PHOTOS = [
    {
        src: "https://images.unsplash.com/photo-1631815587646-b85a1bb027e1?w=1600&q=85",
        alt: "Espace d'accueil et de consultation",
        caption: "L'espace d'accueil",
    },
    {
        src: "https://images.unsplash.com/photo-1666214280391-8ff5bd3c0bf0?w=1600&q=85",
        alt: "Salle de traitement",
        caption: "La salle de traitement",
    },
    {
        src: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1600&q=85",
        alt: "Matériel de rééducation",
        caption: "Le plateau technique",
    },
    {
        src: "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=1600&q=85",
        alt: "Ambiance du cabinet",
        caption: "Un cadre calme",
    },
];
